module.exports = __webpack_public_path__ + "static/media/img_50.a3e62ad4.png";